<template>
  <div class="relative group w-full sm:w-56 flex-shrink-0">
    <GraduationCap
      class="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 dark:text-[#7E8DA5] w-4 h-4 group-focus-within:text-indigo-600 dark:group-focus-within:text-indigo-400 transition-colors pointer-events-none"
    />
    <select
      v-model="selectedClassId"
      @change="handleClassChange"
      class="w-full pl-9 pr-8 py-2.5 border border-slate-200/90 dark:border-[#263449] rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:focus:border-indigo-400 focus:outline-none transition-all duration-200 bg-slate-50 dark:bg-[#18243A] text-slate-800 dark:text-[#F1F5F9] appearance-none disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm shadow-2xs cursor-pointer"
    >
      <option
        value=""
        class="bg-white dark:bg-[#111C30] text-slate-800 dark:text-[#F1F5F9]"
      >
        All Classes
      </option>
      <option
        v-for="cls in classes"
        :key="cls._id"
        :value="cls._id"
        class="truncate bg-white dark:bg-[#111C30] text-slate-800 dark:text-[#F1F5F9]"
        :title="`${cls.name}${cls.section ? ` - ${cls.section}` : ''}`"
      >
        {{ cls.name }}{{ cls.section ? ` - ${cls.section}` : "" }}
      </option>
    </select>
    <ChevronDown
      class="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-400 dark:text-[#7E8DA5] w-4 h-4 pointer-events-none"
    />
  </div>
</template>

<script setup>
  import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { useRoute } from "vue-router";
  import { GraduationCap, ChevronDown } from "lucide-vue-next";

  const store = useStore();
  const route = useRoute();

  const selectedClassId = ref("");
  const classes = computed(() => store.getters.allClasses || []);

  const emit = defineEmits(["selected-class"]);

  onMounted(async () => {
    // Fetch all classes first
    await store.dispatch("fetchAllClasses");

    // If query param exists, set it as selected
    if (route.query.classId) {
      selectedClassId.value = route.query.classId;
    }

    // Emit the selected class (initial load)
    handleClassChange();
  });

  // Emit full class object when dropdown changes
  function handleClassChange() {
    const cls =
      classes.value.find((c) => c._id === selectedClassId.value) || null;
    emit("selected-class", cls); // ✅ emit full class object
  }

  watch(selectedClassId, () => {
    handleClassChange();
  });
</script>
